import { render, staticRenderFns } from "./checkbox-sheet.vue?vue&type=template&id=1e6ec42c"
import script from "./checkbox-sheet.vue?vue&type=script&lang=js"
export * from "./checkbox-sheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./checkbox-sheet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports